import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface RemoveFromPayrollModalProps {
  onSubmit: () => void
  onClose: () => void
}

const RemoveFromPayrollModal = ({ onSubmit, onClose }: RemoveFromPayrollModalProps) => {
  const handleSubmit = () => {
    onClose()
    onSubmit()
  }

  return (
    <Modal
      illustration="alert"
      title={i18n.t('expenses_v2.payroll.remove_supplement_modal.title')}
      description={i18n.t('expenses_v2.payroll.remove_supplement_modal.description')}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('expenses_v2.list.actions.modal.cancel')}
          </Button>
          <Button onClick={handleSubmit}>{i18n.t('expenses_v2.list.actions.modal.remove')}</Button>
        </>
      }
      onClose={onClose}
    />
  )
}

export default observer(RemoveFromPayrollModal)
